import { ComparisonNew } from "@/app/types"
import { GroupCountButton } from "@/components/buttons/button.comparison_group_count"
import { ComparisonSelectorButton } from "@/components/buttons/button.comparison_group_selector"
import { ButtonOverview } from "@/components/buttons/button.overview"
import { EntitySelectorButton } from "@/components/entity/entity.selector_button"
import { Checkbox } from "@/pages/charts/checkbox"
import { useTableauVizInteractive } from "../hooks/use_tableau_interactive"

type TableauVizControlsProps = {
  changeParameterValue: (paramName: string, value: string) => Promise<void>
  slotKey: string | null
}

export function TableauVizControls({
  changeParameterValue,
  slotKey,
}: TableauVizControlsProps) {
  const interactiveData = useTableauVizInteractive({
    changeParameterValue,
    slotKey,
  })

  if (!interactiveData) return null

  const {
    flags,
    isComparisonEnabled,
    isEntityEnabled,
    selectComparison,
    selectEntity,
    comparison,
    entity,
    handleFirmSelection,
    term,
  } = interactiveData

  return (
    <div className="flex flex-col gap-2 pb-4">
      {/* Entity Selection */}
      <div className="flex items-center gap-2">
        {!flags.isLeadersLaggards && (
          <Checkbox
            isChecked={isEntityEnabled}
            onChange={selectEntity}
            disabled={!isComparisonEnabled}
          />
        )}
        <EntitySelectorButton
          showTabs={false}
          entity={entity}
          onSelectFund={() => {}}
          onSelectFirm={handleFirmSelection}
        />
        <ButtonOverview entity={entity} />
      </div>

      {/* Comparison Selection */}
      <div className="mr-2 flex cursor-pointer items-center gap-2">
        {!flags.isLeadersLaggards && (
          <Checkbox
            onChange={selectComparison}
            isChecked={isComparisonEnabled}
            disabled={
              !isEntityEnabled ||
              flags.isPercentileTracker ||
              flags.isCompetitivePositioning
            }
            peer
          />
        )}
        <ComparisonSelectorButton
          entity={entity}
          comparison={comparison}
          comparisonGroupFilter={[ComparisonNew.TOP10]}
        />
        <GroupCountButton term={term} comparison={comparison} />
      </div>
    </div>
  )
}
